export default "__VITE_PUBLIC_ASSET__62670b1c__"